import { render, staticRenderFns } from "./ParentChild.vue?vue&type=template&id=06250e14&scoped=true"
import script from "./ParentChild.vue?vue&type=script&lang=js"
export * from "./ParentChild.vue?vue&type=script&lang=js"
import style0 from "./ParentChild.vue?vue&type=style&index=0&id=06250e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06250e14",
  null
  
)

export default component.exports